module.exports = __webpack_public_path__ + "img/allPlatforms.f78f9ee9.svg";